const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { redirectToVisualizationOfType } from 'src/lib/utils/roadmapping/redirectToVisualizationOfType';
export const Route = createFileRoute('/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/')({
  loader: async ({
    params,
    context: {
      queryClient
    }
  }) => {
    await redirectToVisualizationOfType({
      org: params.org,
      roadmapId: Number(params.roadmapId),
      viewId: Number(params.viewId),
      queryClient
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});